angular.module('app').config(toursRouting);

function toursRouting($routeProvider) {
  $routeProvider
    .when('/tours', {
      pageTitle: 'TOURS',
      template: '<tours-page></tours-page>',
      menu: 'products',
      accessPermission: 'index_tour_accountadmin',
      authReq: true,
    })
    .when('/tours/new', {
      pageTitle: 'ADD_TOUR',
      template: '<tour-page></tour-page>',
      breadcrumb: {
        label: 'TOURS',
        parent: 'tours',
        ajs: true,
      },
      menu: 'products',
      accessPermission: 'create_tour_accountadmin',
      authReq: true,
    })
    .when('/tours/:id', {
      pageTitle: 'TOUR_OVERVIEW',
      template: '<tour-page></tour-page>',
      breadcrumb: {
        label: 'TOURS',
        parent: 'tours',
        ajs: true,
      },
      menu: 'products',
      accessPermission: 'show_tour_accountadmin',
      authReq: true,
    });
}

toursRouting.$inject = ['$routeProvider'];
